import React, { createContext, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const BulkDeployModalContext = createContext({});

export function BulkDeployModalContextProvider({ children }) {
  const [activeModal, setActiveModal] = useState(null);
  const [modalData, setModalData] = useState(null);

  const onOpenModal = (openingModalName, openingModalData) => {
    setActiveModal(openingModalName);
    setModalData(openingModalData);
  };

  const onCloseModal = () => {
    setActiveModal(null);
  };

  return (
    <BulkDeployModalContext.Provider
      value={{
        ...modalData,
        activeModal,
        onOpenModal,
        onCloseModal,
      }}
    >
      {children}
    </BulkDeployModalContext.Provider>
  );
}

BulkDeployModalContextProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useBulkDeployModalContext() {
  return useContext(BulkDeployModalContext);
}
